module.exports = __webpack_public_path__ + "media/images/lb/887-1dd3ef28af8b1a1a21de2ad2c8ed0a7a.svg";